import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class NameComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentName | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? false;
		this.input = settings?.input ?? false;
		this.kdata = {
			path: [],
			...settings?.kdata,
		};
		this.langs = settings?.langs ?? [];
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}
}
